<template>
  <app-side-menu>
    <aside
      class="menu"
      slot="side-menu">
      <p class="menu-label">
        <span class="title is-6">
          Filters
        </span>
      </p>
      <ul class="menu-list">
        <li>
          <div class="field">
            <div class="control">
              <input class="input"
                v-model="innerValue.batchNo"
                type="text"
                placeholder="Batch No."
                @keyup.enter="onFilterClick()">
            </div>
          </div>
          <div class="field">
            <v-date-picker v-model="selectedBatchDate"
              :is-dark="$theme.isDark"
              :masks="formats"
              popover.visibility="focus"
              :attributes="attrs"
              :locale="$userInfo.locale">
              <template v-slot="{ inputValue, inputEvents }">
                <div class="field">
                  <div class="control has-icons-left">
                    <input type="text"
                      class="input"
                      placeholder="Batch Date..."
                      :value="inputValue"
                      v-on="inputEvents">
                    <span class="icon is-small is-left">
                      <i class="mdi mdi-calendar mdi-18px" />
                    </span>
                  </div>
                </div>
              </template>
            </v-date-picker>
          </div>
          <div class="field is-expanded">
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="innerValue.batchStatus">
                  <option v-for="(status, propertyName) in ormBatchStatusType"
                    :value="status"
                    :key="status">
                    {{ $filters.formatOrmBatchStatus(propertyName) }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <hr>
      <div class="field is-grouped is-pulled-right">
        <div class="control">
          <button
            class="button is-primary"
            @click="onFilterClick">
            <span class="icon">
              <i class="mdi mdi-magnify mdi-18px" />
            </span>
            <span>Filter</span>
          </button>
        </div>
        <div class="control">
          <button
            class="button"
            @click="onResetClick">
            <span class="icon">
              <i class="mdi mdi-refresh mdi-18px" />
            </span>
            <span>Reset</span>
          </button>
        </div>
      </div>
    </aside>
  </app-side-menu>
</template>

<script>
import AppSideMenu from '@/components/AppSideMenu'
import { OrmBatchStatusType } from '@/enums'
import OrmBatchingMixin from './OrmBatchingMixin'

export default {
  name: 'OrmMessageListSideMenu',
  components: {
    AppSideMenu
  },
  mixins: [OrmBatchingMixin],
  props: {
    value: null
  },
  data() {
    return {
      innerValue: this.value,
      selectedBatchDate: null,
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'W',
        navMonths: 'MMM',
        input: ['L', 'DD-MM-YYYY', 'DD/MM/YYYY'],
        data: ['L', 'DD-MM-YYYY', 'DD/MM/YYYY'],
        dayPopover: 'L'
      },
      attrs: [
        {
          key: 'today',
          highlight: {
            backgroundColor: '#ff8080'
          },
          popover: {
            label: 'Today'
          },
          dates: new Date()
        }
      ]
    }
  },
  computed: {
    ormBatchStatusType() {
      return OrmBatchStatusType
    }
  },
  watch: {
    innerValue: {
      handler: function(newVal, oldVal) {
        this.$emit('input', newVal)
      },
      deep: true
    },
    value: {
      handler: function(newVal, oldVal) {
        this.innerValue = this.value
      },
      deep: true
    },
    selectedBatchDate(newVal, oldVal) {
      if (newVal) {
        this.innerValue.batchDate = newVal.toISOString().split('.')[0] + 'Z'
      } else {
        this.innerValue.batchDate = null
      }
    }
  },
  created() {
    if (this.value.batchDate) {
      this.selectedBatchDate = new Date(this.value.batchDate)
    }
  },
  mounted() {},
  methods: {
    onFilterClick() {
      this.$emit('filter')
    },
    onResetClick() {
      this.selectedBatchDate = null
      this.$emit('reset')
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/assets/style/mixins/inputs/placeholder' as *;;

input.is-uppercase {
  text-transform: uppercase;
  @include reset-placeholder-text-transform;
}
</style>
